import * as React from 'react';
import { IActionBaseProps } from '../components/action/Action';
import { ControlFacet } from '../models/controls/ControlFacet';
import { IWithWizardInjectedProps } from '../components/decorators/withWizard';

export type IDeleteWizardProps = IWithWizardInjectedProps & {
  onDelete: () => Promise<void>;
  itemKeys: string[];
};

export const deleteActionControler = new ControlFacet<{
  itemKey: string;
  isBatchDelete: boolean
}, {
    isAvailable: boolean;
    deleteWizard: React.ComponentType<IDeleteWizardProps>;
  }>('deleteActionControl');

// @ts-ignore
type __unused_declarations = Pick<
  IActionBaseProps,
  never>;
